import { useContext, useState } from "react";
import { useDispatch } from "react-redux";

import { useNotify } from "data/messages/hooks";

import { useAsyncCall, useMutation } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

import { ToasterContext } from "scenes/Hubly/components/Workspace/Provider";

const mutationFactory = () => {
  const query = `mutation installUseCase($useCaseName: String!) {
      installUseCase(useCaseName: $useCaseName) {
        process {
          uuid
          hub {
            useCases {
              visible
            }
          }
          workflows {
            edges {
              node {
                uuid
                name
                numTasks
                numActiveClients
                numActiveClientWorkflows
                hasWorkflowRules
                isNewTemplate
                canEdit
                clientTileOptions {
                  showProgress
                  showIcons
                  showStreams
                  numberOfTasks
                  presentWorkflowName
                  presentStartDate
                }
                process {
                  uuid
                  color
                  name
                }
              }
            }
          }

        }
      }
    }`;

  const resolver = ({ data }) => {
    const { uuid, workflows, hub } = data.installUseCase.process;

    return {
      data: {
        id: uuid,
        workflows: workflows.edges.map(({ node }) => {
          return { ...node, id: node.uuid };
        }),
        hub: hub,
      },
    };
  };

  return { query: query, resolver: createResolverFactory(resolver) };
};

export function useInstallUseCaseMutation() {
  const [call, loading] = useAsyncCall();
  const [selectedUseCase, setSelectedUseCase] = useState(null);
  const notify = useNotify("WORKFLOWS_TEMPLATE");
  const dispatch = useDispatch();
  const { fireError } = useContext(ToasterContext);

  const mutate = useMutation(mutationFactory);

  const installUseCase = async ({ useCaseName }) => {
    return call(async () => {
      try {
        setSelectedUseCase(useCaseName);

        const { data } = await mutate({ useCaseName });

        if (data?.workflows?.length > 0) notify(data.workflows);

        dispatch({
          type: "SET_HUB_USE_CASES_VISIBILITY",
          visible: data?.hub?.visible || false,
        });

        return data;
      } catch (e) {
        console.error("error", e);
        fireError(
          Array.isArray(e) && e[0]?.message
            ? e[0].message
            : "Failed to install use case, please retry or contact support for assistance",
          e
        );
        return null;
      }
    });
  };

  return { installUseCase, loading, selectedUseCase };
}

export default useInstallUseCaseMutation;
